import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Table} from 'reactstrap';
import CouponItem from "./CouponItem"

class ListCoupons extends Component {
    render() {
        const {coupons} = this.props;

        return (
            <div className="ListCoupon">
                <Table>
                    <thead>
                    <tr>
                        <th>COUPON</th>
                        <th>DISCOUNT</th>
                        <th>USERS</th>
                        <th>DESCRIPTION</th>
                        <th>REDEMPTIONS</th>
                        <th>EXPIRES</th>
                        <th>STATUS</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        coupons.map((coupon) => {
                            return (
                                <CouponItem
                                    coupon={coupon}
                                    key={coupon._id}
                                />
                            )
                        })
                    }
                    </tbody>
                </Table>
            </div>
        );
    }
}

ListCoupons.propTypes = {
    coupons: PropTypes.array.isRequired,
}


export default ListCoupons;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/coupon/CouponPage/components/ListCoupons.js